// @ts-nocheck 11c5e733
import * as core from '#packages/core';
import * as coreBi from '#packages/coreBi';
import * as stateManagement from '#packages/stateManagement';
import * as styles from '#packages/styles';
import * as util from '#packages/util';
import { recompose } from '@wix/santa-editor-utils';
import { EditorParamsApiKey } from '#packages/apis';
import createReactClass from 'create-react-class';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { SiteSegmentMediaBackgroundApiKey } from '#packages/apis';
import { clickInsideDesignPanel } from '@wix/bi-logger-editor-data/v2';
import constants from '#packages/constants';
import type { EditorAPI } from '#packages/editorAPI';
import type { TextTheme } from 'types/documentServices';

const {
  connect,
  STORES: { EDITOR_API },
} = util.hoc;

const { isInInteractionMode } = stateManagement.interactions.selectors;

const { styleUtil } = styles.advancedStyle;
const { advancedStyleDataUtil } = styles.advancedStyle; //getSkinDefaultParams

const DISABLED_UNDO_STACK_PARAM_TYPES = [
  'TEXT_COLOR',
  'COLOR',
  'BG_COLOR',
  'BORDER_COLOR',
]; // alpha has special handling in linkStyleParam
/*, 'COLOR_ALPHA', 'BOX_SHADOW_COLOR_ALPHA', 'BG_COLOR_ALPHA', 'BORDER_COLOR_ALPHA'*/ function isDisabledUndoStackParamType(
  paramType,
) {
  return DISABLED_UNDO_STACK_PARAM_TYPES.includes(paramType);
}

const DEFAULT_FONT_ID = 'font_8';

const toPx = (value: string | undefined) => {
  if (!value) return value;
  const isSpxRegex = /^(-?[\d.]+)spx/;
  if (isSpxRegex.test(value)) {
    return value.replace('spx', 'px');
  }
  return value;
};

const updateStyleDataItem = (styleDataItem, forcedUpdates = {}) => {
  return (previousState) => ({
    ...previousState,
    styleDataItem,
    forcedUpdates,
  });
};

const linkStyle = (Component) =>
  // eslint-disable-next-line react/prefer-es6-class
  createReactClass({
    displayName: recompose.wrapDisplayName(Component, 'LinkStyle'),
    propTypes: {
      selectedComponent: PropTypes.oneOfType([
        PropTypes.object.isRequired,
        PropTypes.array.isRequired,
      ]),
      getStyle: PropTypes.func.isRequired,
      getSkinDefinition: PropTypes.func.isRequired,
      updateStyle: PropTypes.func.isRequired,
      onStyleParamChanged: PropTypes.func,
      maintainOriginalState: PropTypes.func,
      isMultiComponentDesign: PropTypes.bool,
      isInsideEditorX: PropTypes.bool,
      updateOriginalStyleDefs: PropTypes.func,
      multiSelectedComponents: PropTypes.array,
      sendBI: PropTypes.func,
      getAllTextThemes: PropTypes.func,
    },
    getInitialState() {
      this.cachedStylePropertiesForSkins = {};
      const styleDataItem = this.props.getStyle() || {};
      if (!styleDataItem.style) {
        styleDataItem.style = {};
      }
      if (!styleDataItem.style.propertiesOverride) {
        styleDataItem.style.propertiesOverride = {};
      }
      return {
        styleDataItem,
        forcedUpdates: {},
      };
    },
    componentDidMount() {
      this.mounted = true;
    },
    UNSAFE_componentWillReceiveProps(nextProps) {
      const nextStyle = nextProps.getStyle();
      if (!nextStyle) {
        return;
      }
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line you-dont-need-lodash-underscore/for-each
      _.forEach(this.state.forcedUpdates, (v, k) => {
        _.set(nextStyle, `style.properties.${k}`, v);
      });

      if (
        this.props.isMultiComponentDesign &&
        this.props.multiSelectedComponents.some((compRef) =>
          core.styleManager.isEqual(this.props.getStyle(compRef), nextStyle),
        )
      ) {
        if (!nextStyle.style.propertiesOverride) {
          nextStyle.style.propertiesOverride = {};
        }
        this.setState(updateStyleDataItem(nextStyle));
        return;
      }

      const currentStyle = this.props.getStyle();
      if (!currentStyle || core.styleManager.isEqual(currentStyle, nextStyle)) {
        if (!nextStyle.style.propertiesOverride) {
          nextStyle.style.propertiesOverride = {};
        }
        this.setState(updateStyleDataItem(nextStyle));
      }
    },
    componentWillUnmount() {
      this.mounted = false;
    },
    forceUpdateParentStyle(styleDataItem, styleParam, newVal) {
      if (this.props.isMultiComponentDesign) {
        this.props.onStyleParamChanged(
          styleParam,
          newVal,
          styleUtil.getPropertySource(newVal),
        );
      } else {
        this.props.updateStyle(styleDataItem);
      }

      const forcedUpdates = Array.isArray(styleParam)
        ? newVal
        : { [styleParam]: newVal };

      this.setState(updateStyleDataItem(styleDataItem, forcedUpdates));
    },
    sendBIDebounced: _.debounce((sendBi, ...args) => {
      sendBi(...args);
    }, 700),
    onStyleParamChanged(
      originalStyleDataItem,
      styleParam,
      newVal,
      paramDisplayMode,
      dontAddToUndoRedoStack,
      { isMouseOut, isHover },
      styleParamCategory,
      reportOnChange?: (newVal: string) => void,
    ) {
      const { isMultiComponentDesign, maintainOriginalState } = this.props;
      const styleDataItem = _.cloneDeep(originalStyleDataItem);
      const { style } = styleDataItem;
      const value = typeof newVal === 'object' ? newVal.value : newVal;
      const source =
        typeof newVal === 'object'
          ? newVal.source
          : styleUtil.getPropertySource(value);
      const hasStyleParamChanged =
        originalStyleDataItem.style.properties[styleParam] !== value;

      if (style.propertiesOverride) {
        if (
          typeof newVal !== 'object' &&
          source === 'theme' &&
          style.propertiesOverride[styleParam]
        ) {
          delete style.propertiesOverride[styleParam];
        } else if (typeof newVal === 'object' && newVal.overrideValues) {
          style.propertiesOverride[styleParam] = newVal.overrideValues;
        }
      }

      style.properties[styleParam] = value;
      if (style.propertiesSource) {
        style.propertiesSource[styleParam] = source;
      }
      if (isMouseOut && isMultiComponentDesign && maintainOriginalState) {
        this.setState(updateStyleDataItem(styleDataItem));
        return maintainOriginalState(dontAddToUndoRedoStack);
      }

      const hasStyleDataChanged = !_.isEqual(
        styleDataItem,
        originalStyleDataItem,
      );

      if (hasStyleDataChanged && reportOnChange) {
        const stringifyNewVal =
          typeof value !== 'string' ? JSON.stringify(value) : value;
        reportOnChange(stringifyNewVal);
      }

      if (
        this.props.advancedSiteSegmentBackgroundEnabled &&
        styleParam === 'bg-scrl'
      ) {
        // bg scroll depend on regular alphs-bg in style
        styleDataItem.style.properties['alpha-bg'] = '0';
      }

      if (this.props.onStyleParamChanged && hasStyleParamChanged) {
        this.props.onStyleParamChanged(
          styleParam,
          value,
          source,
          this.state.forcedUpdates,
        );
      } else if (hasStyleDataChanged) {
        this.props.updateStyle(
          styleDataItem,
          dontAddToUndoRedoStack,
          undefined,
          undefined,
          undefined,
          undefined,
          isHover,
        );
      }

      if (this.mounted && hasStyleDataChanged) {
        this.setState(updateStyleDataItem(styleDataItem));
      }

      if (isHover === false && this.props.updateOriginalStyleDefs) {
        this.props.updateOriginalStyleDefs();
      }

      const shouldSendBiByComp = [
        constants.COMP_TYPES.HEADER,
        constants.COMP_TYPES.FOOTER,
        constants.COMP_TYPES.CONTAINER,
      ].includes(this.props.compType);

      if (shouldSendBiByComp && hasStyleDataChanged) {
        const biValues = this.props.getBiValuesAdvancedStyle(styleParam);
        if (
          biValues?.field_name === 'color' ||
          biValues?.field_name === 'border_color'
        )
          return;
        util.biLogger.report(
          clickInsideDesignPanel({
            field_value: value,
            component_id:
              this.props.selectedComponent?.id ||
              this.props.selectedComponent?.[0]?.id,
            ...biValues,
            panel_name: constants.PANELS.ADVANCED_SITE_SEGMENT_DESIGN_PANEL,
            component_type: this.props.compType,
          }),
        );
      }

      // we want to limit this BI event to WixStudio only
      if (this.props.isInsideEditorX) {
        this.sendBIDebounced(
          this.props.sendBI,
          coreBi.events.designPanel.BOX_DESIGN_SETTINGS,
          {
            field_name: styleParam,
            field_value: value,
            panel_name: styleParamCategory,
          },
        );
      }
    },
    getStyleDataItemForNewSkin(skinName, oldStyleDataItem) {
      const oldStyle = oldStyleDataItem.style;
      const getSkinDefinitionFunction = this.props.getSkinDefinition;

      const newStyle = styleUtil.getStyleForSkin(
        getSkinDefinitionFunction,
        skinName,
        this.cachedStylePropertiesForSkins[skinName],
      );
      styleUtil.mergeSharedProperties(
        getSkinDefinitionFunction,
        newStyle.properties,
        oldStyle.properties,
        skinName,
        oldStyleDataItem.skin,
      );
      const newStyleDataItem = _.cloneDeep(oldStyleDataItem);
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line you-dont-need-lodash-underscore/assign
      _.assign(newStyleDataItem.style, newStyle);
      newStyleDataItem.skin = skinName;

      return newStyleDataItem;
    },

    linkStyleParam(
      styleParam,
      paramType,
      paramDisplayMode,
      styleParamCategory,
      reportOnChange?: (newVal: string) => void,
    ) {
      if (paramType.includes('COLOR_ALPHA')) {
        return this.linkColorAlphaWithMutator(
          styleParam,
          paramDisplayMode,
          styleParamCategory,
          reportOnChange,
        );
      } else if (paramType.includes('RICH_TEXT')) {
        return this.linkRichTextParam(
          styleParam,
          paramType,
          paramDisplayMode,
          styleParamCategory,
          reportOnChange,
        );
      }
      const { styleDataItem } = this.state;
      const { currentDesign } = this.props;
      const linkParamValue = this.getParamValue(
        styleDataItem,
        styleParam,
        currentDesign,
      );
      let overrideValues = {};

      const { propertiesOverride } = styleDataItem.style;
      if (propertiesOverride && propertiesOverride[styleParam]) {
        overrideValues = propertiesOverride[styleParam];
      }

      return {
        value: linkParamValue,
        overrideValues,
        requestChange: (newVal, { isHover, isMouseOut } = {}) => {
          this.onStyleParamChanged(
            this.state.styleDataItem,
            styleParam,
            newVal,
            paramDisplayMode || 'active',
            isDisabledUndoStackParamType(paramType),
            { isMouseOut, isHover },
            styleParamCategory,
            reportOnChange,
          );
        },
      };
    },
    linkColorAlphaWithMutator(
      colorParam,
      paramDisplayMode,
      styleParamCategory,
      reportOnChange?: (newVal: string) => void,
    ) {
      const alphaParam = `alpha-${colorParam}`;
      const { styleDataItem } = this.state;
      const { currentDesign } = this.props;
      const alphaVal = this.getParamValue(
        styleDataItem,
        alphaParam,
        currentDesign,
      );
      const colorVal = this.getParamValue(
        styleDataItem,
        colorParam,
        currentDesign,
      );

      return {
        value: {
          color: colorVal,
          alpha: alphaVal,
        },
        requestChange: async (colorWithAlpha, { isHover, isMouseOut } = {}) => {
          const { alpha, color } = colorWithAlpha;
          let hasChanges = false;
          const shouldUpdateOpacity =
            this.getParamValue(this.state.styleDataItem, alphaParam) !== alpha;
          if (shouldUpdateOpacity) {
            const { style } = styleDataItem;
            this.onStyleParamChanged(
              this.state.styleDataItem,
              alphaParam,
              alpha,
              paramDisplayMode,
              isDisabledUndoStackParamType(alphaParam),
              { isMouseOut, isHover },
              styleParamCategory,
            );
            style.properties[alphaParam] = alpha;
            hasChanges = true;
          }

          if (
            this.getParamValue(this.state.styleDataItem, colorParam) !== color
          ) {
            if (shouldUpdateOpacity) {
              await this.props.waitForChangesAppliedAsync();
            }
            this.onStyleParamChanged(
              this.state.styleDataItem,
              colorParam,
              color,
              paramDisplayMode,
              isDisabledUndoStackParamType(colorParam),
              { isMouseOut, isHover },
              styleParamCategory,
            );
            hasChanges = true;
          }

          if (!hasChanges && !isHover && this.props.updateOriginalStyleDefs) {
            this.props.updateOriginalStyleDefs();
          }

          if (hasChanges && reportOnChange) {
            const stringifyNewVal =
              typeof colorWithAlpha !== 'string'
                ? JSON.stringify(colorWithAlpha)
                : colorWithAlpha;
            reportOnChange(stringifyNewVal);
          }
        },
      };
    },
    linkRichTextParam(
      styleParam,
      paramType,
      paramDisplayMode,
      styleParamCategory,
      reportOnChange?: (newVal: string) => void,
    ) {
      const { styleDataItem } = this.state;
      const { currentDesign } = this.props;
      const fontId =
        this.getParamValue(styleDataItem, styleParam, currentDesign) ||
        DEFAULT_FONT_ID;
      const themeFonts = this.props.getAllTextThemes();
      const textTheme = themeFonts[fontId] as TextTheme;
      const getFontParamValue = (param) =>
        this.getParamValue(styleDataItem, param, currentDesign);
      const fontSize = getFontParamValue(`fontSize:${styleParam}`);
      const fontWeight = getFontParamValue(`fontWeight:${styleParam}`);
      const fontStyle = getFontParamValue(`fontStyle:${styleParam}`);
      const fontFamily = getFontParamValue(`fontFamily:${styleParam}`);
      return {
        value: fontId,
        overrideValues: {
          fontSize: fontSize || textTheme.fontSize,
          fontWeight: fontWeight || textTheme.fontWeight,
          fontStyle: fontStyle || textTheme.fontStyle,
          fontFamily: fontFamily || textTheme.fontFamily,
        },
        requestChange: (
          newVal:
            | string
            | {
                value: string;
                overrideValues: {
                  fontSize: string;
                  fontWeight: string;
                  fontStyle: string;
                  fontFamily: string;
                };
              },
          { isHover, isMouseOut } = {},
        ) => {
          const value = typeof newVal === 'object' ? newVal.value : newVal;
          const overrideValues =
            typeof newVal === 'object' ? newVal.overrideValues : {};
          const newTextTheme = themeFonts[value] as TextTheme;
          const onFontParamChanged = (param, value) => {
            this.onStyleParamChanged(
              this.state.styleDataItem,
              param,
              value,
              paramDisplayMode || 'active',
              isDisabledUndoStackParamType(param),
              { isMouseOut, isHover },
              styleParamCategory,
              reportOnChange,
            );
          };
          onFontParamChanged(
            `fontSize:${styleParam}`,
            toPx(overrideValues.fontSize || newTextTheme.fontSize),
          );
          onFontParamChanged(
            `fontWeight:${styleParam}`,
            overrideValues.fontWeight || newTextTheme.fontWeight,
          );
          onFontParamChanged(
            `fontStyle:${styleParam}`,
            overrideValues.fontStyle || newTextTheme.fontStyle,
          );
          onFontParamChanged(
            `fontFamily:${styleParam}`,
            overrideValues.fontFamily || newTextTheme.fontFamily,
          );
        },
      };
    },
    cacheStylePropertiesForSkin(skinName, styleProperties) {
      this.cachedStylePropertiesForSkins[skinName] = styleProperties;
    },
    changeSkin(skinName) {
      const oldStyleDataItem = this.state.styleDataItem;

      if (skinName === oldStyleDataItem.skin) {
        return;
      }

      const styleDataItem = this.getStyleDataItemForNewSkin(
        skinName,
        oldStyleDataItem,
      );

      this.cacheStylePropertiesForSkin(
        oldStyleDataItem.skin,
        oldStyleDataItem.style.properties,
      );
      this.props.updateStyle(styleDataItem);
      this.setState({ styleDataItem });
    },
    getParamValue(styleDataItem, paramKey, designDataItem) {
      const getSkinDefinitionFunction = this.props.getSkinDefinition;
      const paramValue = styleDataItem.style.properties[paramKey];

      if (paramValue !== undefined) return paramValue;

      const shouldOverrideScrollValue =
        paramKey.endsWith('scrl') &&
        this.props.advancedSiteSegmentBackgroundEnabled;
      if (shouldOverrideScrollValue) {
        return this.getParamValueForScroll(
          styleDataItem,
          paramKey,
          designDataItem,
        );
      }

      return advancedStyleDataUtil.getSkinParamDefaultValue(
        getSkinDefinitionFunction,
        styleDataItem.skin,
        paramKey,
      );
    },
    getParamValueForScroll(styleDataItem, paramKey, designDataItem) {
      const regularKey = paramKey.replace('-scrl', '');
      let value;
      if (regularKey === 'bg' && designDataItem) {
        value = util.colorPickerUtils.getColorValue(designDataItem?.background);
      }
      if (regularKey === 'alpha-bg' && designDataItem) {
        value = util.colorPickerUtils.getOpacityValue(
          designDataItem?.background,
        );
      }
      return value === undefined
        ? styleDataItem.style.properties[regularKey]
        : value;
    },
    render() {
      const props = _.defaults(
        {
          linkStyleParam: this.linkStyleParam,
          changeSkin: this.changeSkin,
          forceUpdateParentStyle: this.forceUpdateParentStyle,
          styleDataItem: this.state.styleDataItem,
        },
        this.props,
      );

      return React.createElement(Component, props);
    },
  });

const getSkinDefinition =
  (skinName) =>
  (dispatch, getState, { dsRead }) =>
    dsRead.theme.skins.getSkinDefinition(skinName);
const updateStyle =
  (selectedComponent, styleDef) =>
  (dispatch, getState, { editorAPI }) =>
    editorAPI.components.style.update(selectedComponent, styleDef);
const getStyle =
  (selectedComponent) =>
  (dispatch, getState, { editorAPI }) =>
    editorAPI.components.style.get(selectedComponent);

const mapStateToProps = ({ editorAPI }, ownProps) => {
  const editorParamsApi = editorAPI.host.getAPI(EditorParamsApiKey);
  const shouldResetToggledOffShadow = !isInInteractionMode(
    editorAPI.store.getState(),
  );
  const isInsideEditorX = editorParamsApi.isInsideEditorX;
  const selectedComp =
    ownProps.selectedComponents?.[0] || ownProps.selectedComponent;

  const currentStyle = editorAPI.components.style.get(selectedComp);
  const currentDesign = editorAPI.components.design.get(selectedComp);

  const SiteSegmentMediaBackgroundApi = editorAPI.host.getAPI(
    SiteSegmentMediaBackgroundApiKey,
  );
  const advancedSiteSegmentBackgroundEnabled =
    SiteSegmentMediaBackgroundApi.advancedSiteSegmentBackgroundEnabled(
      selectedComp,
    );
  const getBiValuesAdvancedStyle = (paramName: string) =>
    SiteSegmentMediaBackgroundApi.getBiValuesAdvancedStyle(paramName);

  return {
    shouldResetToggledOffShadow,
    isInsideEditorX,
    currentStyle,
    currentDesign,
    advancedSiteSegmentBackgroundEnabled,
    getBiValuesAdvancedStyle,
    getAllTextThemes: editorAPI.theme.textThemes.getAll,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const getEditorAPI: ThunkAction<EditorAPI> = (
    dispatch,
    getState,
    { editorAPI },
  ) => editorAPI;

  const editorAPI = dispatch(getEditorAPI);

  return {
    getSkinDefinition: (skinName) => dispatch(getSkinDefinition(skinName)),
    sendBI: (event, params) =>
      dispatch(
        stateManagement.bi.actions.event(
          event,
          Object.assign(
            {
              component_type: ownProps.compType,
              component_id: ownProps.selectedComponents?.[0]?.id,
            },
            params,
          ),
        ),
      ),
    showMigrationNotification: (
      options: stateManagement.ShowUserActionNotificationParam,
    ) => {
      const { showUserActionNotification } =
        stateManagement.notifications.actions;
      dispatch(showUserActionNotification(options));
    },
    waitForChangesAppliedAsync:
      editorAPI.documentServices.waitForChangesAppliedAsync,
    updateStyle:
      ownProps.updateStyle ||
      ((styleDef) =>
        dispatch(updateStyle(ownProps.selectedComponent, styleDef))),
    getStyle:
      ownProps.getStyle ||
      (() => dispatch(getStyle(ownProps.selectedComponent))),
  };
};

export default _.flow(
  linkStyle,
  connect(EDITOR_API, mapStateToProps, mapDispatchToProps),
);
